module.exports = __webpack_public_path__ + "static/media/ar.bf17357d.svg";